import {Injectable} from "@angular/core";
import {HandlerError, HttpErrorHandlerService} from "../../../core/services/http-error-handler.service";
import {HttpClient} from "@angular/common/http";
import {environment} from "../../../../environments/environment";
import {NovoProcesso} from "../models/novo-processo";
import {catchError, Observable} from "rxjs";
import {BaseResponse} from "../../../core/models/base-response";
import {ListaProcesso} from "../models/lista-processo";
import {DetalhesProcesso} from "../models/detalhes-processo";
import {AlterarProcesso} from "../models/alterar-processo";

@Injectable({
  providedIn: 'root'
})
export class ProcessoService {
  private handlerErro: HandlerError;

  constructor(
    private http: HttpClient,
    httpErrorHandler: HttpErrorHandlerService) {
    this.handlerErro = httpErrorHandler.createHandleError(`ProcessoService`);
  }

  baseUrl = environment.apiUrl;

  adicionar(request: NovoProcesso): Observable<BaseResponse<DetalhesProcesso> | BaseResponse<any>>{
    return this.http
      .post<BaseResponse<DetalhesProcesso>>(`${this.baseUrl}/Processo`, request)
      .pipe(catchError(this.handlerErro<BaseResponse<any>>('adicionar')));
  }

  alterar(request: AlterarProcesso): Observable<BaseResponse<boolean> | BaseResponse<any>>{
    return this.http
      .put<BaseResponse<boolean>>(`${this.baseUrl}/Processo`, request)
      .pipe(catchError(this.handlerErro<BaseResponse<any>>('alterar')));
  }

  selecionarLista(): Observable<BaseResponse<ListaProcesso> | BaseResponse<any>> {
    return this.http
      .get<BaseResponse<ListaProcesso>>(`${this.baseUrl}/Processo`)
      .pipe(catchError(this.handlerErro<BaseResponse<any>>('selecionarLista')));
  }

  buscarPorId(id: number): Observable<BaseResponse<DetalhesProcesso> | BaseResponse<any>> {
    return this.http
      .get<BaseResponse<DetalhesProcesso>>(`${this.baseUrl}/Processo/${id}`)
      .pipe(catchError(this.handlerErro<BaseResponse<any>>('buscarPorId')));
  }
}
